import cx from 'classnames';
import { useCallback } from 'react';

import { useTrackEventAmplitude } from '../../../core/Tracking/Amplitude/Amplitude';
import { AnchorWithArrow } from '../../../design-system/components/anchor/AnchorWithArrow';
import { TwoColumnTextSlice } from '../../../domains/Prismic/DestinationDetailDocument';
import { EvaneosPrismicRichText } from '../../../domains/Prismic/EvaneosPrismicRichText';
import { NullableSlice } from '../../../domains/Prismic/Utilities';

import style from './TwoColumnText.module.css';

export type TwoColumnTextProps = {
    twoColumnText: NullableSlice<TwoColumnTextSlice>;
    row: number;
};

export function TwoColumnText({ twoColumnText, row }: TwoColumnTextProps) {
    const { trackEvent } = useTrackEventAmplitude();
    const handleClickButton = useCallback(() => {
        trackEvent((ampli, defaultProperties) => {
            ampli.marketingDestinationDetailsCtaClicked({
                ...defaultProperties,
                block: 'two_column_text',
                url_redirection: twoColumnText.rightLink?.url ?? '',
                row_number: row,
            });
        });
    }, [row, trackEvent, twoColumnText.rightLink?.url]);

    return (
        <div className={style.wrapper}>
            <div className={style.leftColumn}>
                <div className={cx('font-secondary-s-regular', style.title)}>
                    {twoColumnText.leftColumnTitle}
                </div>
            </div>
            <div className={style.rightColumn}>
                <EvaneosPrismicRichText field={twoColumnText.rightColumnText} />
                {twoColumnText.rightLink?.url && twoColumnText.rightLink?.label ? (
                    <AnchorWithArrow
                        className={style.link}
                        href={twoColumnText.rightLink?.url}
                        onClick={handleClickButton}
                    >
                        {twoColumnText.rightLink?.label}
                    </AnchorWithArrow>
                ) : null}
            </div>
        </div>
    );
}
